const SVG_NAMESPACE = "http://www.w3.org/2000/svg";

function icon(paths: readonly string[]): SVGSVGElement {
  const svg = document.createElementNS(SVG_NAMESPACE, "svg");
  svg.setAttribute("viewBox", "0 0 24 24");
  svg.setAttribute("aria-hidden", "true");
  svg.setAttribute("class", "control-icon");
  for (const pathData of paths) {
    const path = document.createElementNS(SVG_NAMESPACE, "path");
    path.setAttribute("d", pathData);
    svg.append(path);
  }
  return svg;
}

export function playIcon(): SVGSVGElement {
  return icon(["M8 5v14l11-7z"]);
}

export function pauseIcon(): SVGSVGElement {
  return icon(["M7 5h4v14H7z", "M13 5h4v14h-4z"]);
}

export function closeIcon(): SVGSVGElement {
  return icon(["M6 6l12 12M18 6L6 18"]);
}

export function copyIcon(): SVGSVGElement {
  return icon(["M8 8h11v11H8z", "M5 16H4V5h11v1"]);
}

export function compassIcon(): SVGSVGElement {
  return icon(["M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z", "m15.5 8.5-2 5-5 2 2-5z"]);
}
